module.exports = __webpack_public_path__ + "img/another-menu-m2x.cea0708.jpg";